export class Time {
  private lastTime: number = 0;
  private currentTime: number = 0;
  private _deltaTime: number = 0;
  private _frameCount: number = 0;
  private _elapsedTime: number = 0;
  private _fps: number = 0;
  private fpsUpdateInterval: number = 1000; // Update FPS every second
  private fpsLastUpdate: number = 0;
  private fpsFrameCount: number = 0;
  
  constructor() {
    this.reset();
  }
  
  public start(): void {
    this.reset();
    this.currentTime = performance.now();
    this.lastTime = this.currentTime;
  }
  
  public stop(): void {
    // Nothing needed here, the loop will stop calling update
  }
  
  public reset(): void {
    this.lastTime = 0;
    this.currentTime = 0;
    this._deltaTime = 0;
    this._frameCount = 0;
    this._elapsedTime = 0;
    this._fps = 0;
    this.fpsLastUpdate = 0;
    this.fpsFrameCount = 0;
  }
  
  public update(): void {
    this.currentTime = performance.now();
    
    // Calculate time since last frame in seconds
    this._deltaTime = (this.currentTime - this.lastTime) / 1000;
    
    // Update elapsed time in seconds
    this._elapsedTime += this._deltaTime;
    
    // Update frame count
    this._frameCount++;
    this.fpsFrameCount++;
    
    // Calculate FPS every second
    if (this.currentTime - this.fpsLastUpdate >= this.fpsUpdateInterval) {
      this._fps = Math.round(this.fpsFrameCount / ((this.currentTime - this.fpsLastUpdate) / 1000));
      this.fpsLastUpdate = this.currentTime;
      this.fpsFrameCount = 0;
    }
    
    // Store current time as last time for next frame
    this.lastTime = this.currentTime;
  }
  
  public get deltaTime(): number {
    return this._deltaTime;
  }
  
  public get frameCount(): number {
    return this._frameCount;
  }
  
  public get elapsedTime(): number {
    return this._elapsedTime;
  }
  
  public get fps(): number {
    return this._fps;
  }
}
